module.exports = {
  dev: {
    API_URL: "http://localhost:1337/cms",
  },
  stag: {
    API_URL: "https://stag.mimeapi.com/cms",
  }
};